import type { useTranslations } from "next-intl";

/**
 * Kanzlei P5 (02.11.2026): the backend refuses a test mail up front when a
 * recipient is on the platform suppression list — `recipientSuppressed`, with
 * the listed addresses (as typed) in `suppressedRecipients`. Shared by the
 * builder's test dialog (PTestMail) and the send dialogs (useTestMail).
 */
export const RECIPIENT_SUPPRESSED = "recipientSuppressed";

type AppbarTranslator = ReturnType<typeof useTranslations<"emailAppbar">>;

/** The listed addresses, or `undefined` when the value carries none. */
export function suppressedRecipientsOf(value: unknown): string[] | undefined {
  if (!value || typeof value !== "object") return undefined;
  const list = (value as { suppressedRecipients?: unknown }).suppressedRecipients;
  if (!Array.isArray(list)) return undefined;
  const clean = list.filter((a): a is string => typeof a === "string" && a.length > 0);
  return clean.length > 0 ? clean : undefined;
}

/**
 * "No test email sent. On the do-not-send list: a@x, b@y". `null` when the
 * code is not ours or no address came with it — the caller then takes its
 * normal path (`errors.recipientSuppressed` is the fallback text).
 */
export function suppressedRecipientsMessage(
  tAppbar: AppbarTranslator,
  code: unknown,
  list: readonly string[] | undefined,
): string | null {
  if (code !== RECIPIENT_SUPPRESSED || !list || list.length === 0) return null;
  return tAppbar("recipientSuppressedList", { addresses: list.join(", ") });
}
